import classnames from 'classnames/bind';
import React, { forwardRef } from 'react';
import styles from './styles.module.scss';

export interface PaperProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  style?: Record<string, any>;
  className?: string;
  fullWidth?: boolean;
}

const cx = classnames.bind(styles);

export const Paper = forwardRef<HTMLDivElement, PaperProps>(({ fullWidth = true, ...props }, ref) => (
  <div
    onClick={props.onClick}
    ref={ref}
    style={props.style}
    className={cx(styles.wrapper, props.className, {
      fullWidth
    })}>
    {props.children}
  </div>
));

Paper.displayName = 'Paper';
